const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

if (params && params.error && params.error === 'invalid_role') {
  // eslint-disable-next-line no-alert -- deliberate user-facing notice for this login error
  alert(
    'Het is niet mogelijk om op deze wijze in te loggen met een account met admin rol(len), gebruik hiervoor OneLogin (vergeet niet uit te loggen via https://mijnomgeving.vtwonen.nl/).'
  );
}
